import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { OrbitIconsPipe } from "../pipes/orbit-icons.pipe";

@NgModule({
    imports: [IonicModule,CommonModule],
    declarations:[OrbitIconsPipe],
    exports:[OrbitIconsPipe]
})
export class IconModule{}